module.exports = __webpack_public_path__ + "static/media/ploni-demibold-aaa.86534211.woff2";